export const CameraPermissionStatuses = Object.freeze({
    REQUESTING_CAMERA_PERMISSION: 'prompt',
    ACCESS_DENIED: 'denied',
    ACCESS_GRANTED: 'granted',
    NO_CAMERA: "no_camera"
});